import React from 'react';
import Section from './Section';

/*
props = {
  data: {
    sections: [{
      uId: <uniqueIdentifier>,
      contents: []
    },...]
  }
}
*/

const ReportContent = (props) => {
  const { sections } = props.data;

  return (
    <div>
      { sections.map((section) => <Section key={ section.uId } data={ section } />) }
    </div>
  );
};

export default ReportContent;